import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";
import Pagination from "react-js-pagination";
import Modal from "react-bootstrap/Modal";
import useFullPageLoader from "../../hooks/useFullPageLoader";
import useButtonLoader from "../../hooks/useButtonLoader";
import { Url } from "../../config/config";
import ReactQuill from "react-quill";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";

export default function JobsManagement() {
  const [record, setRecord] = useState([]);
  const [total, setTotal] = useState(0);
  const [activePage, setActivePage] = useState(1);
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const [inputField, setInputField] = useState({
    id: "",
    title: "",
    department: "",
    description: "",
    experience: 0,
    numberOfVacancies: 0,
    location: "",
  });
  const [errorField, setErrorField] = useState({
    title: "",
    department: "",
    description: "",
    experience: null,
    numberOfVacancies: null,
    location: "",
  });
  const [submitButtonElement, setSubmitLoading] = useButtonLoader(
    "Submit",
    "Please wait..."
  );

  //handle delete
  const [DeleteModal, setDeleteModal] = useState(false);
  const handelDeleteShow = (id) => {
    //console.log(id);
    setDeleteModal(true);
    setInputField({ ...inputField, id: id });
  };
  const handelDeleteClose = () => {
    setDeleteModal(false);
  };

  const handelDelete = async () => {
    try {
      const res = await axios({
        url: `${Url}/delete-Job/${inputField.id}`,
        method: "DELETE",
      });
      if (res.data.status === 200) {
        handelDeleteClose();
        toast.success(res.data.message);
        jobListHandler(activePage);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  //***********Block UnBlock*************** */
  const [BlockModal, setBlockModal] = useState(false);
  const handelBlockShow = () => {
    setBlockModal(true);
  };

  const handelBlockClose = () => {
    setBlockModal(false);
  };
  const handleChecked = (status, id) => {
    handelBlockShow();
    setInputField({
      ...inputField,
      status: status === "open" ? "close" : "open",
      id: id,
    });
  };

  const handelUpdateStatus = async () => {
    try {
      console.log(inputField);
      const res = await axios({
        url: `${Url}/update-Job-Status`,
        method: "PUT",
        data: {
          id: inputField.id,
          status: inputField.status,
        },
      });
      console.log(res);
      if (res.data.status === 200) {
        handelBlockClose();
        toast.success(res.data.message);
        jobListHandler(activePage);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };
  //***************Add Banner *********** */
  const [AddModal, setAddModal] = useState(false);
  const handelAddModalShow = () => {
    setInputField("");
    setErrorField("");
    setAddModal(true);
  };
  const handelAddModalClose = () => {
    setAddModal(false);
  };
  const handelInputChange = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    setInputField({
      ...inputField,
      [name]: value,
    });
  };

  //*************Handel Validation************** */
  const handleValidation = () => {
    let errorField = {};
    let formIsValid = true;

    if (!inputField.title) {
      errorField.title = "Title is required";
      formIsValid = false;
    }

    if (!inputField.department) {
      errorField.department = "Department is required";
      formIsValid = false;
    }

    if (!inputField.description) {
      errorField.description = "Description is required";
      formIsValid = false;
    }

    if (!inputField.experience || inputField.experience < 0) {
      errorField.experience = "Valid experience is required";
      formIsValid = false;
    }

    if (!inputField.numberOfVacancies || inputField.numberOfVacancies < 1) {
      errorField.numberOfVacancies = "Vacancies must be at least 1";
      formIsValid = false;
    }

    if (!inputField.location) {
      errorField.location = "Location is required";
      formIsValid = false;
    }

    setErrorField(errorField);
    setSubmitLoading(false);
    return formIsValid;
  };

  //*************Handel Submit*************** */
  const handelSubmit = async () => {
    try {
      setSubmitLoading(true);
      if (handleValidation()) {
        let res = await axios({
          url: `${Url}/add-Job`,
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
          data: {
            title: inputField.title,
            department: inputField.department,
            description: inputField.description,
            experience: inputField.experience,
            numberOfVacancies: inputField.numberOfVacancies,
            location: inputField.location,
          },
        });

        setSubmitLoading(false);
        if (res.data.status === 200) {
          handelAddModalClose();
          setInputField("");
          setErrorField("");
          jobListHandler(activePage);
          toast.success(res.data.message);
        } else if (res.data.status === 419) {
          toast.error(res.data.message);
        } else {
          toast.error("Something went to wrong");
        }
      }
    } catch (err) {
      console.log(err);
    }
  };

  //*************Handel Edit *************** */
  const [EditModal, setEditModal] = useState(false);
  const handelEditModalClose = () => {
    setEditModal(false);
  };
  const handelEditModalShow = (data) => {
    setEditModal(true);
    setInputField({ ...data, id: data._id });
  };
  const handelEditSubmit = async () => {
    try {
      setSubmitLoading(true);
      const res = await axios({
        url: `${Url}/update-Job`,
        method: "PUT",
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
        },
        data: {
          id: inputField.id,
          title: inputField.title,
          department: inputField.department,
          description: inputField.description,
          experience: inputField.experience,
          numberOfVacancies: inputField.numberOfVacancies,
          location: inputField.location,
        },
      });
      setSubmitLoading(false);
      if (res.data.status === 200) {
        handelEditModalClose();
        jobListHandler(activePage);
        toast.success(res.data.message);
      } else if (res.data.status === 419) {
        toast.error(res.data.message);
      } else {
        toast.error("Something went to wrong");
      }
    } catch (err) {
      console.log(err);
    }
  };

  const jobListHandler = async (page = 1, query = "") => {
    try {
      showLoader();
      const res = await axios({
        url: `${Url}/job-List?page=${page}&search=${query}`,
        method: "GET",
        headers: {
          //Authorization: "Bearer " + accessToken,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
      });
      hideLoader();

      if (res.data.status === 200) {
        setRecord(res.data.data.jobList);
        setTotal(res.data.data.total);
      }
    } catch (err) {
      console.log(err);
    }
    // console.log(res.data.result);
  };

  useEffect(() => {
    jobListHandler(activePage);
    // eslint-disable-next-line
  }, []);

  //*********Handel Search************** */
  const handelSearch = (e) => {
    //setSearch(e.target.value);
    jobListHandler(activePage, e.target.value);
    // console.log(e.target.value);
  };

  //***********Handel pagination*********** */
  const handlePageChange = (pageNo) => {
    setActivePage(pageNo);
    jobListHandler(pageNo);
  };
  var count = (activePage - 1) * 10 + 1;
  const modules = {
    toolbar: [
      [{ header: [1, 2, false] }],
      ["bold", "italic", "underline"],
      ["blockquote", "code-block"],
      [{ list: "ordered" }, { list: "bullet" }],
      ["link", "image"],
      ["clean"],
    ],
  };
  console.log(inputField, "inputfield");
  return (
    <React.Fragment>
      <title>Jobs Management</title>
      <div className="WrapperArea">
        <div className="WrapperBox">
          <div className="Small-Wrapper">
            <div className="SearchBox">
              <input
                type="text"
                placeholder="Search .."
                onChange={handelSearch}
              />
              <button
                className="button py-auto"
                type="button"
                onClick={handelAddModalShow}
              >
                Add&nbsp;Jobs
              </button>
            </div>
            <h4 className="Title">Jobs Management</h4>
            {loader}
            <div className="TableList">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Job Title</th>
                    <th className="nowrap">Dep. Name</th>
                    <th className="nowrap">Experience</th>
                    <th className="nowrap">NO. Vacancies</th>
                    <th className="nowrap">Location</th>
                    {/* <th className="nowrap">Description</th> */}
                    <th className="nowrap">View Applicants</th>
                    <th>Status</th>

                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {record &&
                    record.length > 0 &&
                    record.map((item, i) => (
                      <tr key={i}>
                        <td>{count++}</td>
                        <td>{item.title}</td>
                        <td>{item.department}</td>
                        <td>{item.experience}</td>
                        <td>{item.numberOfVacancies}</td>
                        <td>{item.location}</td>
                        {/* <td
                          dangerouslySetInnerHTML={{ __html: item.description }}
                        ></td> */}
                        <td>
                          <Link to={`applicant/${item._id}`}>
                            View ({item.applicantCount || 0})
                          </Link>
                        </td>
                        <td>
                          <button
                            type="button"
                            className={item?.status === "open" ? "status_btn open" : "status_btn close"}
                            onClick={() =>
                              handleChecked(item?.status, item._id)
                            }
                          >
                            {item?.status === "open" ? "Open" : "Close"}
                          </button>
                        </td>
                        <td>
                          <span
                            className="Green inline-block"
                            onClick={(e) => handelEditModalShow(item)}
                          >
                            <i className="fa fa-edit"></i>
                          </span>
                          <span
                            className="Red inline-block"
                            onClick={(e) => handelDeleteShow(item._id)}
                          >
                            <i className="fa fa-trash"></i>
                          </span>
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            {total > 10 ? (
              <div className="Pagination">
                <Pagination
                  activePage={activePage}
                  previousLabel={"previous"}
                  nextLabel={"next"}
                  itemsCountPerPage={10}
                  totalItemsCount={total}
                  pageRangeDisplayed={5}
                  onChange={handlePageChange}
                />
              </div>
            ) : null}
          </div>
        </div>
      </div>

      <div className="ModalBox">
        {/* Add modal */}
        <Modal
          show={AddModal}
          // style={{ opacity: 1 }}
          onHide={handelAddModalClose}
        >
          <Modal.Header closeButton onClick={handelAddModalClose}>
            <Modal.Title>Add New Job</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form method="POST">
              <div className="form-group">
                <label>Title</label>
                <input
                  type="text"
                  className="form-control"
                  name="title"
                  placeholder="Enter Title"
                  value={inputField.title}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.title}
                </span>
              </div>

              <div className="form-group">
                <label>Department</label>
                <input
                  type="text"
                  className="form-control"
                  name="department"
                  placeholder="Enter Department"
                  value={inputField.department}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.department}
                </span>
              </div>

              <div className="form-group">
                <label>Description</label>
                <ReactQuill
                  theme="snow"
                  value={inputField.description}
                  onChange={(value) =>
                    setInputField({ ...inputField, description: value })
                  }
                  modules={modules}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.description}
                </span>
              </div>

              <div className="form-group">
                <label>Experience (Years)</label>
                <input
                  type="number"
                  className="form-control"
                  name="experience"
                  placeholder="Enter Experience"
                  value={inputField.experience}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.experience}
                </span>
              </div>

              <div className="form-group">
                <label>Number of Vacancies</label>
                <input
                  type="number"
                  className="form-control"
                  name="numberOfVacancies"
                  placeholder="Enter Vacancies"
                  value={inputField.numberOfVacancies}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.numberOfVacancies}
                </span>
              </div>

              <div className="form-group">
                <label>Location</label>
                <input
                  type="text"
                  className="form-control"
                  name="location"
                  placeholder="Enter Location"
                  value={inputField.location}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.location}
                </span>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            <button variant="secondary" onClick={handelAddModalClose}>
              Close
            </button>
            <button
              className="primary"
              variant="primary"
              onClick={handelSubmit}
              ref={submitButtonElement}
            >
              Save
            </button>
          </Modal.Footer>
        </Modal>
        {/* End add Modal */}

        {/* Edit modal */}
        <Modal
          show={EditModal}
          // style={{ opacity: 1 }}
          onHide={handelEditModalClose}
        >
          <Modal.Header closeButton onClick={handelEditModalClose}>
            <Modal.Title>Edit Jobs</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <form method="POST">
              <div className="form-group">
                <label>Title</label>
                <input
                  type="text"
                  className="form-control"
                  name="title"
                  placeholder="Enter Title"
                  value={inputField.title}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.title}
                </span>
              </div>

              <div className="form-group">
                <label>Department</label>
                <input
                  type="text"
                  className="form-control"
                  name="department"
                  placeholder="Enter Department"
                  value={inputField.department}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.department}
                </span>
              </div>

              <div className="form-group">
                <label>Description</label>
                <ReactQuill
                  theme="snow"
                  value={inputField.description}
                  onChange={(value) =>
                    setInputField({ ...inputField, description: value })
                  }
                  modules={modules}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.description}
                </span>
              </div>

              <div className="form-group">
                <label>Experience (Years)</label>
                <input
                  type="number"
                  className="form-control"
                  name="experience"
                  placeholder="Enter Experience"
                  value={inputField.experience}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.experience}
                </span>
              </div>

              <div className="form-group">
                <label>Number of Vacancies</label>
                <input
                  type="number"
                  className="form-control"
                  name="numberOfVacancies"
                  placeholder="Enter Vacancies"
                  value={inputField.numberOfVacancies}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.numberOfVacancies}
                </span>
              </div>

              <div className="form-group">
                <label>Location</label>
                <input
                  type="text"
                  className="form-control"
                  name="location"
                  placeholder="Enter Location"
                  value={inputField.location}
                  onChange={handelInputChange}
                />
                <span style={{ color: "red" }} className="error">
                  {errorField.location}
                </span>
              </div>
            </form>
          </Modal.Body>
          <Modal.Footer>
            {/* <button variant="secondary" onClick={handelEditModalClose}>
              Close
            </button> */}
            <button
              className="primary"
              variant="primary"
              onClick={handelEditSubmit}
              ref={submitButtonElement}
            >
              Save
            </button>
          </Modal.Footer>
        </Modal>
        {/* End edit Modal */}

        {/* Start Delete Modal */}
        <Modal
          show={DeleteModal}
          //style={{ opacity: 1 }}
          onHide={handelDeleteClose}
        >
          <Modal.Header closeButton onClick={handelDeleteClose}>
            <Modal.Title>Delete</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to delete this testimonial?</Modal.Body>
          <Modal.Footer>
            <button
              className="primary"
              variant="secondary"
              onClick={handelDeleteClose}
            >
              No
            </button>
            <button
              className="secondary"
              variant="primary"
              onClick={handelDelete}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
        {/* End delete Modal */}

        {/* block or unblock model */}
        <Modal show={BlockModal} onHide={handelBlockClose}>
          <Modal.Header closeButton onClick={handelBlockClose}>
            <Modal.Title>Change Status</Modal.Title>
          </Modal.Header>
          <Modal.Body>Are you sure want to change the status?</Modal.Body>
          <Modal.Footer>
            <button
              className="secondary"
              variant="secondary"
              onClick={handelBlockClose}
            >
              No
            </button>
            <button
              className="primary"
              variant="primary"
              onClick={handelUpdateStatus}
            >
              Yes
            </button>
          </Modal.Footer>
        </Modal>
        {/* end block unblock modal */}
      </div>
    </React.Fragment>
  );
}
